import * as types from './../constants/bannerActionTypes';

function banners(state = [], action) {
  switch (action.type) {
    case types.BANNER_LOAD_REQUEST:
    case types.BANNER_LOAD_FAILURE:
      return state;

    case types.BANNER_LOAD_SUCCESS:
      return [...action.banners];

    default:
      return state;
  }
}

export default banners;
